import { useEffect, useState } from 'react';
import { random } from 'lodash';
import React from 'react';

const PlacementCard = () => {
  const placedUserImages = [
    'PlacedUser1.webp',
    'PlacedUser2.webp',
    'PlacedUser3.webp',
    'PlacedUser4.webp',
    'PlacedUser5.webp',
  ];

  const [currentImage, setCurrentImage] = useState(
    placedUserImages[random(0, placedUserImages.length - 1)],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const nextImage =
        placedUserImages[random(0, placedUserImages.length - 1)];
      setCurrentImage(nextImage);
    }, 5000); // change every 5 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <div className="flex items-center justify-center">
      <img
        src={`/images/Testimonial/${currentImage}`}
        alt="Placement User"
        className="mx-4 w-full object-cover md:h-[400px]"
      />
    </div>
  );
};

export default PlacementCard;
